// extracted by mini-css-extract-plugin
export default {"wrapper":"PopupBanner_wrapper__dGPGe","fadeInUp":"PopupBanner_fadeInUp__g+L4Q","content":"PopupBanner_content__reSgV","icon":"PopupBanner_icon__KpvVA"};